import { getLang, t } from './i18n';
// Copy of functions/src/schedule.ts (occursOn/isAssigned). Keep the two in sync.

export type Repeat =
  | { type: 'daily' }
  | { type: 'weekly'; days: number[] } // 0 = Sunday
  | { type: 'monthly'; daysOfMonth: number[] }
  | { type: 'once'; date: string };

interface Schedulable {
  repeat: Repeat;
  assignees: string[];
  startDate?: string;
  endDate?: string;
}

export function occursOn(task: Schedulable, date: string): boolean {
  if (task.startDate && date < task.startDate) return false;
  if (task.endDate && date > task.endDate) return false;
  const r = task.repeat as Partial<Record<string, unknown>> | undefined;
  if (!r || typeof r !== 'object') return false; // a malformed shared task never crashes the app
  const d = new Date(date + 'T12:00:00Z');
  switch (r.type) {
    case 'daily':
      return true;
    case 'weekly':
      return Array.isArray(r.days) && r.days.includes(d.getUTCDay());
    case 'monthly':
      return Array.isArray(r.daysOfMonth) && r.daysOfMonth.includes(d.getUTCDate());
    case 'once':
      return r.date === date;
    default:
      return false;
  }
}

export function isAssigned(task: Schedulable, uid: string): boolean {
  return !Array.isArray(task.assignees) || task.assignees.length === 0 || task.assignees.includes(uid);
}

export const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function describeRepeat(r: Repeat): string {
  switch (r.type) {
    case 'daily':
      return t('Every day');
    case 'weekly':
      return r.days.length === 7 ? t('Every day') : r.days.map((d) => t(DAY_SHORT[d])).join(', ');
    case 'monthly':
      return getLang() === 'tr' ? `Her ayın ${r.daysOfMonth.join(' ve ')}. günü` : `Monthly on the ${r.daysOfMonth.map(ordinal).join(' and ')}`;
    case 'once':
      return t('Once, {date}', { date: r.date });
  }
}

function ordinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
